import {
  ForwardedRef,
  forwardRef,
  InputHTMLAttributes,
  MouseEvent,
  useState,
} from 'react'

import HidePasswordIcon from '../../assets/svg/hide-password.svg?react'
import ShowPasswordIcon from '../../assets/svg/show-password.svg?react'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  variant?: 'primary' | 'secondary' | 'third' | 'danger'
  placeholder?: string
  type: 'text' | 'password'
  helperText?: string
}

export const Input = forwardRef(
  (
    {
      variant = 'primary',
      className,
      placeholder,
      helperText,
      type,
      ...rest
    }: InputProps,
    ref: ForwardedRef<HTMLInputElement>,
  ) => {
    const variantClasses = {
      primary:
        'shadow-md w-full order-blue-500 focus:border-blue-600 mb-5 placeholder-black',
      secondary: 'border-gray-300 focus:border-gray-400 placeholder-black',
      third:
        'shadow-md w-full order-blue-500 focus:border-blue-600 mb-2 placeholder-[#c1c1c1]',
      danger:
        'shadow-md bg-red-50 border border-red-500 text-red-900 ' +
        'placeholder-red-700 text-sm rounded-lg focus:ring-red-500 ' +
        'focus:border-red-500 block w-full p-2.5',
    }

    const [showPassword, setShowPassword] = useState(false)

    const togglePasswordVisibility = (
      e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>,
    ) => {
      e.stopPropagation()
      setShowPassword(!showPassword)
    }

    return (
      <div className="relative">
        <input
          ref={ref}
          placeholder={placeholder}
          type={showPassword ? 'text' : type}
          className={`rounded-md border px-4 py-4
          focus:outline-none focus:ring-2 focus:ring-${variant}-500 ${variantClasses[variant]} ${className}`}
          {...rest}
        />
        {type === 'password' ? (
          <button
            type="button"
            onClick={(e) => togglePasswordVisibility(e)}
            className="absolute end-0 top-0 rounded-e-md p-3.5
            dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
          >
            {showPassword ? (
              <ShowPasswordIcon style={{ width: '14px' }} />
            ) : (
              <HidePasswordIcon style={{ width: '14px' }} />
            )}
          </button>
        ) : null}
        <p className="mt-2 mb-4 text-sm text-red-600">{helperText}</p>
      </div>
    )
  },
)
